import * as Yup from 'yup';

export const companySchema = Yup.object({
  companyName: Yup.string().required('โปรดระบุชื่อบริษัทให้ถูกต้อง'),
  fname: Yup.string().required('โปรดระบุชื่อให้ถูกต้อง'),
  lname: Yup.string().required('โปรดระบุนามสกุลให้ถูกต้อง'),
  phoneNumber: Yup.string()
    .min(10, 'โปรดระบุเบอร์โทรศัพท์อย่างน้อย 10 หลัก')
    .required('โปรดระบุเบอร์โทรศัพท์ให้ถูกต้อง'),
  state: Yup.string().required('โปรดระบุสถานะให้ถูกต้อง'),
});

export const addCompanySchema = Yup.object({
  code: Yup.string().required('โปรดระบุรหัสบริษัทให้ถูกต้อง'),
  companyName: Yup.string().required('โปรดระบุชื่อบริษัทให้ถูกต้อง'),
  spendingCriteria: Yup.number()
    .min(0, 'ยอดใช้จ่ายต้องไม่ติดลบ')
    .required('โปรดระบุยอดใช้จ่ายให้ถูกต้อง'),
});
